import { Button } from "@/components/ui/button";
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { createFileRoute, Link, redirect } from "@tanstack/react-router";
import { Trans, useTranslation } from "react-i18next";

export const Route = createFileRoute("/verify-email")({
  component: RouteComponent,
  beforeLoad: ({ context: { authentication } }) => {
    if (
      authentication &&
      authentication.session &&
      authentication.session.user.confirmed_at
    ) {
      throw redirect({ to: "/project-create-or-join" });
    }
  },
});

function RouteComponent() {
  const searchParams = Route.useSearch() as { email?: string };
  const { t } = useTranslation();

  return (
    <div className="w-full h-dvh flex items-center justify-center">
      <div className="w-full max-w-xl px-5">
        <Card>
          <CardHeader>
            <CardTitle>{t("verifyEmail.title")}</CardTitle>
            <CardDescription>
              {t("verifyEmail.description")}
              {searchParams.email && (
                <>
                  {" "}
                  <Trans
                    i18nKey="verifyEmail.emailSpecific"
                    values={{ email: searchParams.email }}
                    components={{
                      1: <span className="font-bold text-foreground" />
                    }}
                  />
                </>
              )}
            </CardDescription>
          </CardHeader>
        </Card>
        <div className="flex items-center justify-center mt-6">
          <Link to="/login">
            <Button variant="ghost">{t("verifyEmail.backToLogin")}</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
